import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { SafeImage } from '@/components/marketplace/SafeImage';

export const AddedToCartModal = ({ open, onClose, ad }) => {
    const navigate = useNavigate();
    if (!ad) return null;
    const image = ad.media?.find(m => m.kind === 'image')?.url;

    const handleSellerProducts = () => {
        onClose();
        navigate(`/u/${ad.seller_nickname}`);
    };
    const handleGoCart = () => {
        onClose();
        navigate('/carrito');
    };
    const handleContinue = () => {
        onClose();
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-sm p-0 overflow-hidden rounded-2xl">
                <div className="flex flex-col items-center p-6 gap-4">
                    <CheckCircle2 className="h-10 w-10 text-green-500" />
                    <p className="text-lg font-semibold text-center">Agregaste a tu carrito</p>
                    {image && (
                        <div className="w-24 h-24 rounded-xl overflow-hidden border bg-muted flex-shrink-0">
                            <SafeImage src={image} alt={ad.title} className="w-full h-full object-cover" />
                        </div>
                    )}
                    <p className="text-sm text-center text-foreground font-medium line-clamp-2">{ad.title}</p>
                    <div className="flex flex-col gap-2 w-full mt-1">
                        <Button variant="outline" className="w-full" onClick={handleSellerProducts}>
                            Ver más productos del vendedor
                        </Button>
                        <Button className="w-full bg-red-600 hover:bg-red-700 text-white" onClick={handleGoCart}>
                            Ir al carrito
                        </Button>
                        <Button variant="ghost" className="w-full" onClick={handleContinue}>
                            Seguir comprando
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
